import { nakiRadioSystemTypes } from "common/constants";
import BaseHomeSectionListViewStore from "./BaseHomeSectionListViewStore";

class NakiMobileHandheldHomeSectionListViewStore extends BaseHomeSectionListViewStore {
    constructor(rootStore, { routeStore }) {
        super(rootStore, { routeStore });
        this.mobileAppSystemType = nakiRadioSystemTypes.mobile_handheld;
    }
}

export default NakiMobileHandheldHomeSectionListViewStore;
